import React, { useState, useEffect } from 'react'
import useTrans from '../../../../hooks/useTrans'
import IndirizzoCard from '../../../molecules/NewIndirizzoCard/IndirizzoCard'
import NewModal from '../../../molecules/NewModal/NewModal'
import { Button } from '../../../atoms'
import { Plus, Search } from '../../../atoms/NewIcons'
import { useSelector } from 'react-redux'

const SceltaIndirizzo = ({
  indirizzo,
  indirizzi,
  setIndirizzo,
  onClose,
  handleAddIndirizzo,
  handleSetIndirizzo,
  handleEditIndirizzo,
  handleDeleteIndirizzo,
}) => {
  const t = useTrans()
  const { service_gift } = useSelector((state) => state.servicegift)

  const [selected, setSelected] = useState(indirizzo?.id)
  const [searchValue, setSearchValue] = useState('')
  const [filteredIndirizzi, setFilteredIndirizzi] = useState(indirizzi)

  useEffect(() => {
    if (selected && selected !== indirizzo?.id) {
      setIndirizzo(selected)
    }
  }, [selected])

  useEffect(() => {
    if (indirizzi) {
      if (searchValue) {
        const lowered = searchValue.toLowerCase()
        const newIndirizzi = indirizzi.filter(
          (x) =>
            x.ragione_sociale?.toLowerCase().includes(lowered) ||
            x.indirizzo?.toLowerCase().includes(lowered) ||
            x.citta?.toLowerCase().includes(lowered) ||
            x.cap?.toLowerCase().includes(lowered) ||
            x.nazione?.nome?.toLowerCase().includes(lowered) ||
            x.nome?.toLowerCase().includes(lowered) ||
            x.cognome?.toLowerCase().includes(lowered)
        )
        setFilteredIndirizzi(newIndirizzi)
      } else {
        setFilteredIndirizzi(indirizzi)
      }
    }
  }, [indirizzi, searchValue])

  return (
    <NewModal
      variant="checkout"
      visible={true}
      onClose={onClose}
      title={
        service_gift
          ? indirizzo?.is_fatturazione
            ? t('Dati di fatturazione')
            : t('Indirizzi di consegna')
          : t('I tuoi indirizzi')
      }
      actions={
        <>
          <Button
            variant="ghost"
            label={t('Aggiungi un nuovo indirizzo')}
            icon={<Plus />}
            icon_pos="left"
            onClick={() => handleAddIndirizzo()}
          />
          <Button
            variant="primary"
            onClick={() => handleSetIndirizzo()}
            label={t('Utilizza questo indirizzo')}
          />
        </>
      }
    >
      <div className="scelta_indirizzo">
        <div className="scelta_indirizzo__section">
          <p className="scelta_indirizzo__subtitle">
            {service_gift
              ? indirizzo?.is_fatturazione
                ? t('Dati di fatturazione selezionati')
                : t('Indirizzo di consegna selezionato')
              : t('Indirizzo selezionato')}
          </p>
          <IndirizzoCard
            variant="checkout"
            indirizzo={indirizzo}
            key={indirizzo?.id}
            onEdit={handleEditIndirizzo}
            isSelected={indirizzo?.id === selected}
            setSelected={setSelected}
            selectable
          />
        </div>
        <div className="scelta_indirizzo__section">
          <p className="scelta_indirizzo__subtitle">
            {service_gift
              ? indirizzo?.is_fatturazione
                ? t('Altri dati di fatturazione')
                : t('Altri indirizzi di consegna')
              : t('Altri indirizzi')}{' '}
            ({indirizzi.length})
          </p>
          {indirizzi.length > 0 && (
            <div className="scelta_indirizzo__search">
              <input
                value={searchValue}
                className="search-bar__input"
                placeholder={t('Cerca per ragione sociale,indirizzo,città ...')}
                onChange={(e) => {
                  setSearchValue(e.target.value)
                }}
              />
              <a className="search-bar__icon">
                <Search />
              </a>
            </div>
          )}
          <div className="scelta_indirizzo__others">
            <div className="scelta_indirizzo__others__results">
              {filteredIndirizzi.map((otherIndirizzo) => {
                return (
                  <IndirizzoCard
                    variant="checkout"
                    indirizzo={otherIndirizzo}
                    key={otherIndirizzo.id}
                    onDelete={handleDeleteIndirizzo}
                    onEdit={handleEditIndirizzo}
                    isSelected={otherIndirizzo.id === selected}
                    setSelected={setSelected}
                    selectable
                  />
                )
              })}
            </div>

            {filteredIndirizzi?.length === 0 && searchValue && (
              <div className="scelta_indirizzo__others__empty">
                <p>
                  {t('Nessun risultato per')} <span>{searchValue}</span>
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </NewModal>
  )
}

export default SceltaIndirizzo
